module.exports = __webpack_public_path__ + "static/media/manufacturing-microone-01 3.0327e34f.png";